export enum RestaurantStatusEnum {
  open = 'open',
  closed = 'closed',
  disabled = 'disabled',
  archived = 'archived',
}
